const shareHelper = {
  shareToLine: async (groupCode, shareUrl) => {
    try {
      const message = `ชวนมาร่วมตี้มูเตลู พร้อมร่วมสรงน้ำเสริมสิริมงคลที่ Big C 🌼
👉 เข้าร่วมเลย`
      const encodedMessage = encodeURIComponent(message)
      const lineShareUrl = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(shareUrl)}&text=${encodedMessage}`

      const shareWindow = window.open(
        lineShareUrl,
        '_blank',
        'width=600,height=800,scrollbars=yes,resizable=yes'
      )

      if (!shareWindow || shareWindow.closed || typeof shareWindow.closed === 'undefined') {
        window.location.href = lineShareUrl
        return { success: true, method: 'redirect' }
      }

      return { success: true, method: 'popup' }
    } catch (error) {
      return shareHelper.copyToClipboard(shareUrl)
    }
  },

  shareToLineMobile: (groupCode, shareUrl) => {
    try {
      const message = `ชวนมาร่วมตี้มูเตลู พร้อมร่วมสรงน้ำเสริมสิริมงคลที่ Big C 🌼
👉 เข้าร่วมเลย
${shareUrl}`

      const encodedMessage = encodeURIComponent(message)
      const lineAppUrl = `line://msg/text/${encodedMessage}`
      window.location.href = lineAppUrl
      return { success: true, method: 'line_app' }
    } catch (error) {
      return shareHelper.copyToClipboard(shareUrl)
    }
  },

  smartShare: (groupCode, shareUrl) => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    if (isMobile) return shareHelper.shareToLineMobile(groupCode, shareUrl)
    return shareHelper.shareToLine(groupCode, shareUrl)
  },

  copyToClipboard: async (url) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url)
        return { success: true, method: 'clipboard' }
      }

      const textArea = document.createElement('textarea')
      textArea.value = url
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      return { success: true, method: 'clipboard_legacy' }
    } catch (error) {
      return { success: false, method: 'clipboard_failed' }
    }
  }
}

export default shareHelper
